import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Button, Alert } from 'react-bootstrap';
import { TitleWMutedRow } from '../../../../sitel/demon/ui/atoms';
import { FieldValidationErrorMsg, HelpText } from '../../../../sitel/demon/ui/atoms/form';
import useOriginApp from '../../../../services/useOriginApp';
import useShowHidePassword from '../../../new/step2Credentials/useShowHidePassword';

import schema from './formSchema';
import useFormSubmit from './useFormSubmit';
import SubmitButton from '../../../../sitel/demon/ui/atoms/buttons/SubmitButton';

export default function Step3ChangePassword() {
  const [submitStatus, setSubmitStatus] = useState('idle');
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting, isSubmitSuccessful },
  } = useForm({ resolver: yupResolver(schema()) });
  const onSubmit = useFormSubmit(submitStatus, setSubmitStatus);
  const [showHidePassword, setshowHidePassword] = useShowHidePassword();
  const originApp = useOriginApp();
  if (submitStatus === 'submit-success') {
    return (
      <Alert variant='success'>
        <Alert.Heading>Password has been changed</Alert.Heading>
        You can now continue to <a href={originApp.url}>{originApp.name}</a>
      </Alert>
    );
  }

  if (submitStatus === 'failed') {
    return (
      <Alert variant='danger'>
        <Alert.Heading>Password did not change</Alert.Heading>
        An unknown error has occured and your password was not changed.
        <br />
        Please try again later.
        <hr />
        You can still continue to <a href={originApp.url}>{originApp.name}</a>
      </Alert>
    );
  }

  return (
    <>
      <TitleWMutedRow muted='This will delete your previous password and is not reversible'>Reset password</TitleWMutedRow>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className='form-row'>
          <div className='form-group'>
            <label htmlFor='sesame1'>Enter new password</label>
            <div className='borderx position-relative'>
              <input type={showHidePassword.inputType} className='form-control border w-100' id='sesame1' placeholder='Password' {...register('sesame1')} />
              <span role='button' className='position-absolute top-50 end-0 translate-middle' onClick={setshowHidePassword}>
                <i className={`fa-regular ${showHidePassword.check ? 'fa-eye' : 'fa-eye-slash'}`}></i>
              </span>
            </div>
            <FieldValidationErrorMsg field='sesame1' errors={errors} />
          </div>
          <div className='form-group mt-2'>
            <label>Repeat new password</label>
            <input type={showHidePassword.inputType} className='form-control' id='sesame2' placeholder='Confirm' {...register('sesame2')} />
            <FieldValidationErrorMsg field='sesame2' errors={errors} />
            <HelpText>Must contain eight characters, one uppercase, one lowercase, one number and one special case character</HelpText>
          </div>
        </div>
        <div className='form-row'>
          <div className='form-group'>
            <SubmitButton isSubmitting={isSubmitting} isSubmitSuccessful={isSubmitSuccessful} defaultLabel="Reset your password" className="btn-medstar-primary w-100 mt-3"/>
          </div>
        </div>
        <div className='form-row'>
          <div className='form-group'>
            <Button variant='dark' className='btn-medstar-outline w-100 mt-2' href={originApp.url}>
              Cancel reset password and continue to {originApp.name}
            </Button>
          </div>
        </div>
      </form>
    </>
  );
}
